import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'polaKerja'
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE
const outputType = 'json'

export const polaKerjaCreate = 'Master/WorkingPattern/create/'
export const polaKerjaList = 'Master/WorkingPattern/list/'
export const polaKerjaDetail = 'Master/WorkingPattern/detail/'
export const polaKerjaUpdate = 'Master/WorkingPattern/update/'
export const polaKerjaInactive = 'Master/WorkingPattern/inactive/'
export const polaKerjaActive = 'Master/WorkingPattern/active/'

export const jamKerjaCreate = 'Master/WorkingHours/create/'
export const jamKerjaList = 'Master/WorkingHours/list/'
export const jamKerjaDetail = 'Master/WorkingHours/detail/'
export const jamKerjaUpdate = 'Master/WorkingHours/update/'
export const jamKerjaInactive = 'Master/WorkingHours/inactive/'
export const jamKerjaActive = 'Master/WorkingHours/active/'

export const flexytimeList = 'Master/Flexytime/list/'
export const presensiLocationList = 'Master/WorkingPattern/listPresensiLocation/'

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}